import React from 'react';
import { ButtonClean, useModalContext } from '@fourthwall/components';
import { AddSubscriptionModal } from '../modules/AddSubscriptionModal/AddSubscriptionModal';
import { SubscriptionLimitModal } from '../modules/SubscriptionLimitModal/SubscriptionLimitModal';
import { useSubscription } from './useSubscription';
export const useSubscriptionOffers = () => {
    const { open } = useModalContext();
    const { offers, activeSubscription, canUpgradeSubscription } = useSubscription();
    const shouldShowLimitsModal = activeSubscription && offers.hasLimit && !offers.canCreate && !canUpgradeSubscription;
    const shouldShowUpgradeModal = !offers.canCreate;
    const openSubscriptionOffersLimitModal = () => {
        if (!shouldShowLimitsModal)
            return;
        open(SubscriptionLimitModal, {
            title: 'Products limit reached',
            content: (React.createElement(React.Fragment, null,
                "You've created ",
                activeSubscription.offers.usage,
                " out of ",
                activeSubscription.offers.limit,
                ' ',
                "products allowed on your current plan. To stay within the limit, consider archiving any unused products or",
                ' ',
                React.createElement(ButtonClean, { to: "mailto:support@fourthwall.com", label: "contact our support team" }),
                ".")),
        });
    };
    const openSubscriptionOffersUpgradeModal = ({ source, onSuccess, } = {}) => {
        if (!shouldShowUpgradeModal)
            return;
        open(AddSubscriptionModal, {
            title: `Upgrade your plan to offer more than ${activeSubscription?.offers.limit || 100} products`,
            source,
            onSuccess,
        });
    };
    return {
        shouldShowLimitsModal,
        shouldShowUpgradeModal,
        openSubscriptionOffersLimitModal,
        openSubscriptionOffersUpgradeModal,
    };
};
